export default __webpack_public_path__ + "static/media/cases4.98d94e83.webp";